<template>
<button type="button" class="plus-button plus-button--small exclude-outside-click" ><img class="exclude-outside-click" @click="handleClick" src="@/csmworkflow/img/plus.svg" /></button>
</template>

<script>
export default {
  name: "PlusButton",
  props: {
  	text: {
  		type:String,
  		default: null
  	}
  },


  methods: {
  	handleClick() {
  		this.$emit('click');
  	}

  }



};
</script>
